import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { CustomMenuItem } from 'models/digitalMap';
import { useSelector } from 'react-redux';
import { getCustomMenuItems } from './util';

export const useDigitalMapCustomMenuItems = (): CustomMenuItem[] => {
  const digitalMap = useSelector(selectDigitalMap);

  return getCustomMenuItems(digitalMap);
};
